import { Done, QuestionMarkOutlined } from '@mui/icons-material';
import { SvgIcon } from '@mui/material';
import { ReactComponent as ExclamationMarkIcon } from 'assets/icons/ExclamationMark.svg';
import { checkingStatuses } from 'keys/checkingStatuses';

const useMarkerTypes = () => {

    const markerTypes = {
        [checkingStatuses.confirmed]: {
            icon: <Done color="white"/>
        },
        [checkingStatuses.question]: {
            icon: <QuestionMarkOutlined color="white"/>
        },
        [checkingStatuses.recheck]: {
            icon: <SvgIcon fontSize="small" component={ExclamationMarkIcon} inheritViewBox />
        },
        ["default"]: {
            icon: <QuestionMarkOutlined sx={{ color: "#969CA5" }} />
        }
    }

    return markerTypes
}

export default useMarkerTypes